import { NavLink } from 'react-router-dom';

import { useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';

import FormProvider from '@webclient/components/react-hook-form/FormProvider';
import FormHeading from '@webclient/components/user-authentication/components/form-heading';

import MailIcon from '~icons/knowz-iconify/mail-rounded';

import { Text } from '@knowz/knowz-ui';

type Props = {
  children: React.ReactNode;
  slots: {
    header?: React.ComponentProps<typeof FormHeading>;
    form: Omit<React.ComponentProps<typeof FormProvider>, 'children'>;
  };
};

export default function BaseStep({ slots: { header, form }, children }: Props) {
  const theme = useTheme();

  return (
    <Stack
      justifyContent="space-between"
      sx={{ height: '100%' }}
    >
      <FormProvider {...form}>
        {header && <FormHeading {...header} />}

        <Stack
          gap={4}
          sx={{ marginBlockStart: header ? 5 : 0 }}
        >
          {children}
        </Stack>
      </FormProvider>

      <Stack
        gap={2}
        direction="row"
        alignItems="center"
        component={NavLink}
        to="mailto:help@knowz.com"
        sx={{
          color: 'text.tertiary',
        }}
      >
        <MailIcon color={theme.palette.utility.gray700} />
        <Text variant="textSm">help@knowz.com</Text>
      </Stack>
    </Stack>
  );
}
